import { useState } from 'react';

import { Step1 } from './step1';
import { Step2 } from './step2';
import { Step3 } from './step3';
import { Step4 } from './step4';

import './styles.css';

export default function Process({
  onFinish
}) {
  const [currentStep, setCurrentStep] = useState(1);
  const [isAnimating, setIsAnimating] = useState(false);
  const [animationDirection, setAnimationDirection] = useState('next');

  const handleNextStep = () => {
    if (!isAnimating) {
      setAnimationDirection('next');
      setIsAnimating(true);
      
      setTimeout(() => {
        if(currentStep === 4) {
          onFinish();
        } else {
          setCurrentStep(currentStep + 1);
          setIsAnimating(false);
        }
      }, 300);
    }
  };

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <Step1 onNext={handleNextStep} />
        );
      case 2:
        return (
          <Step2 onNext={handleNextStep} />
        );
      case 3:
        return (
          <Step3 onNext={handleNextStep} />
        );
      case 4:
        return (
          <Step4 onNext={handleNextStep} />
        );
      default:
        return <Step1 onNext={handleNextStep} />;
    }
  };

  return (
    <div className="onboarding-process">      
      <div className={`step-container ${isAnimating ? `animating-${animationDirection}` : ''}`}>
        {renderStep()}
      </div>
    </div>
  )
};